<ng-container>
  <div class="joint-maintenance" fxLayout="column">
    <app-applicants [isInJointMaintenanceFlow]="true"></app-applicants>
    <app-bsa-profile
      *ngIf="!shouldHideBsaQuestions"
      [reviewState]="reviewState"
      [hasCoApplicant]="false"
    ></app-bsa-profile>
  </div>
</ng-container>
